// Font awesome
import { faEye } from "@fortawesome/free-solid-svg-icons";
// Fhir front library
import { SearchableTable, FhirStatus, StatusTag } from "@fyrstain/fhir-front-library";
// Translation
import i18n from "i18next";
// React
import { FunctionComponent, useCallback } from "react";
// Navigation
import { useNavigate } from "react-router-dom";
// Component
import PandoraPage from '../../components/PandoraPage/PandoraPage';

const TestReports: FunctionComponent = () => {

    //////////////////////////////
    //        Navigation        //
    //////////////////////////////

    const navigate = useNavigate();

    const onDetail = useCallback((id: string) => {
        navigate("/TestReportDetails/" + id);
    }, [navigate]);

    //////////////////////////////
    //           Error          //
    //////////////////////////////

    const onError = useCallback((error?: unknown) => {
        navigate("/Error", { state: { error } });
    }, [navigate]);

    //////////////////////////////
    //          Content         //
    //////////////////////////////

    return (
        <PandoraPage titleKey='title.testreports' needsLogin={true}>
            <SearchableTable
                searchCriteriaProperties={{
                    title: i18n.t('title.searchcriteria'),
                    submitButtonLabel: i18n.t('button.search'),
                    resetButtonLabel: i18n.t('button.reset'),
                    language: i18n.t,
                    fixedParameters:
                    {
                        _elements: "id,name,status,result,issued",
                        _sort: "-_lastUpdated",
                    },
                    inputs: [
                        {
                            label: "ID",
                            type: "text",
                            placeholder: i18n.t('placeholder.id'),
                            searchParamsName: "_id",
                        },
                        {
                            label: i18n.t('label.name'),
                            type: "text",
                            placeholder: i18n.t('placeholder.name'),
                            searchParamsName: "name:contains",
                        },
                    ],
                }}
                paginatedTableProperties={{
                    columns: [
                        {
                            header: "ID",
                            dataField: "id",
                            width: "25%",
                        },
                        {
                            header: i18n.t('label.name'),
                            dataField: "name",
                            width: "35%",
                        },
                        {
                            header: i18n.t('label.status'),
                            dataField: "status",
                            formatter: (cell: keyof typeof FhirStatus) => {
                                return <StatusTag
                                    status={FhirStatus[cell]}
                                    statusMessage={cell}
                                />;
                            },
                        },
                        {
                            header: i18n.t('label.result'),
                            dataField: "result",
                            formatter: (cell: keyof typeof FhirStatus) => {
                                return <StatusTag
                                    status={FhirStatus[cell]}
                                    statusMessage={cell}
                                />;
                            },
                        },
                    ],
                    action: [
                        {
                            icon: faEye,
                            onClick: onDetail,
                        },
                    ],
                    mapResourceToData: (resource: any) => {
                        return {
                            id: resource.id,
                            name: resource.name,
                            status: resource.status,
                            result: resource.result,
                        };
                    },
                    searchProperties: {
                        serverUrl: process.env.REACT_APP_FHIR_URL ?? 'fhir',
                        resourceType: 'TestReport',
                    },
                    onError: onError,
                }}
            />
        </PandoraPage>
    );
};

export default TestReports;
